function HandleCartMembershipClick( event )
{
    const toggle = event.target.closest( ".js-cart-membership-toggle" );
    const opener = event.target.closest( ".js-cart-membership-open" );
    const closer = event.target.closest( ".js-cart-membership-close" );

    if ( toggle )
    {
        const card     = toggle.closest( ".cart-membership-card" );
        const expanded = toggle.getAttribute( "aria-expanded" ) != "true";

        card.classList.toggle( "cart-membership-card--expanded", expanded );
        toggle.setAttribute( "aria-expanded", expanded );
        toggle.textContent = expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
    }
    else if ( opener )
    {
        const dialog = document.querySelector( ".cart-membership-dialog" );

        if ( dialog )
        {
            event.preventDefault();
            dialog.showModal();
        }
    }
    else if ( closer )
    {
        closer.closest( ".cart-membership-dialog" ).close();
    }
    else if ( event.target.matches( ".cart-membership-dialog" ) )
    {
        event.target.close();
    }
}

function InitCartMembershipDialog()
{
    const root = document.documentElement;

    if ( root.dataset.cartMembershipInitialized != "true" )
    {
        document.addEventListener( "click", HandleCartMembershipClick );
        root.dataset.cartMembershipInitialized = "true";
    }
}

InitCartMembershipDialog();
